export default __webpack_public_path__ + "static/media/Ellipse.2d88302f.svg";